export default {

  getVehicleCallout: function (seriesCode, vehicleNavCallouts) {
    var result = '';
    if (vehicleNavCallouts) {
      vehicleNavCallouts.forEach(function (e) {
        if (seriesCode && (e.series && e.series === seriesCode)) {
          result = e.text;
        }
        return result;
      });
    }
    return result;
  }

};
